<template>
  <v-container fluid>
    <v-row  dense>
      <v-col cols="12">
        <DataTableMainServer :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"
          :Updatepagination="params" :on-pagination="pagePagination" :on-search="getSearchPagePagination"/>
        <ViewDetails :object="object" type="Seguimiento" />
        <ReportDialog :dialog2="openDialog"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import ViewDetails from '@/components/ViewDetails'
import ReportDialog from '@/components/dialog/ReportDialog'
export default {
  mixins: [Permission],
  data: () => ({
    openDialog: false,
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          {
            title: 'Reportes',
            icon: 'mdi-cloud-download',
            color: 'light-blue lighten-1',
            code: 'libre',
            hidden: '',
            options: [
              { title: 'Reporte', icon: 'mdi-file-excel', color: 'blue-grey lighten-1', action: 'showDialogFechas', pagination: {}, code: 'libre', hidden: '' },
              { title: 'Documentos', icon: 'mdi-file-excel', color: 'blue-grey lighten-1', action: 'showDialogFechasDoc', pagination: {}, code: 'seguimiento.get-reportedocumentos' },
              { title: 'Facturas', icon: 'mdi-zip-box', color: 'amber lighten-1', action: 'showDialogFechasFac', pagination: {}, code: 'seguimiento.facturas-zip' },
              { title: 'Facturas y XML', icon: 'mdi-zip-box', color: 'amber lighten-1', action: 'showDialogFechasFacXml', pagination: {}, code: 'seguimiento.facturas-zip2' }
            ]
          }
        ],
        titles: [
          { text: 'Folio Fiscal', value: 'factura.FolioAb', class: 'black--text' },
          { text: 'Proveedor', value: 'factura.proveedor.nombre', class: 'black--text' },
          { text: 'Solicitante', value: 'solicitante.NombreCompleto', class: 'black--text' },
          { text: 'Estatus', value: 'Status', align: 'center', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text', align: 'right' }
        ],
        loading: false,
        filter: false,
        select_year: true
      },
      body: {
        data: [],
        actions: [
          { title: 'Ver documentos', icon: 'mdi-clipboard-text', color: 'blue-grey lighten-1', action: 'verDocumentos', code: 'seguimiento.descargar-docs-solicitud' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    default: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    user: {},
    year: null
  }),
  components: {
    DataTableMainServer,
    ViewDetails,
    ReportDialog
  },
  mounted () {
    this.user = UserSession()
    // this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'POSTPagination', 'PUTDisableEnableObjectService', 'DELETEObjectService']),
    ...mapMutations(['CLEAR_OBJECTS', 'SHOW_DIALOG_MAIN', 'SHOW_DIALOG_ALERT_MAIN', 'SEND_DATA_VIEW', 'SHOW_DIALOG_REPORT']),
    SuccessTableAction (item) { this[item.action](item) },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTPagination({ url: router, data: this.params })
      } else {
        this.getUrlServices()
      }
    },
    SelectYear (obj) {
      this.year = obj.item.year
      this.params.year = obj.item.year
      this.refreshData()
    },
    // *==========*==========*==========*    Methods Table Pagination    *==========*==========*==========* \\
    pagePagination (val) {
      this.table.header.loading = true

      if (val) this.params = val
      else this.params = this.default
      this.params.year = this.year
      this.ExecuteUrl('seguimiento.list-pagination')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.params.year = this.year
      this.ExecuteUrl('seguimiento.list-pagination')
    },
    // *==========*==========*==========*==========*==========*==========*==========*==========*==========* \\
    // *==========*==========*==========*==========*==========*==========*==========*==========*==========* \\
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('seguimiento.list-pagination')
    },
    toAssign (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '35%',
        title: 'Asignar Solicitud',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item
          }
        }
      })
    },
    toReturnCompleteData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '35%',
        title: 'Rechazar Solicitud',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item
          }
        }
      })
    },
    toCompleteData (item) {
      const data = {
        ubp_ids: item.item.descripcion.ubp_ids,
        // tiene_contrato: item.item.descripcion.tiene_contrato,
        tiene_contrato: (item.item.descripcion.tiene_contrato) ? item.item.descripcion.tiene_contrato : 'no',
        contrato_id: item.item.descripcion.contrato_id,
        contrato: item.item.contrato,
        unidad_id: item.item.descripcion.unidad_id,
        factura_id: item.item.descripcion.factura_id,
        empleado_id: item.item.descripcion.empleado_id,
        comprador_id: item.item.descripcion.comprador_id,
        comprador: item.item.comprador,
        fOrdenSalida: item.item.descripcion.fOrdenSalida,
        departamento_id: item.item.descripcion.departamento_id,
        monto_autorizado: item.item.descripcion.monto_autorizado,
        poliza_devengado: item.item.descripcion.poliza_devengado,
        poliza_comprometido: item.item.descripcion.poliza_comprometido,
        tipo_adjudicacion_id: item.item.descripcion.tipo_adjudicacion_id,
        fuente_financiamiento_id: item.item.descripcion.fuente_financiamiento_id,
        fTurnadoSubdireccionFinanciera: item.item.descripcion.fTurnadoSubdireccionFinanciera,
        folio_respuesta_suficiencia_presupuestal: item.item.descripcion.folio_respuesta_suficiencia_presupuestal,
        poliza_ejercido: item.item.descripcion.poliza_ejercido,
        poliza_pagado: item.item.descripcion.poliza_pagado,
        importe_pagado: item.item.descripcion.importe_pagado,
        fPagado: item.item.descripcion.fPagado
      }
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '55%',
        title: 'Completar datos',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: data,
            returnObject: true
          }
        }
      })
    },
    toAssingType (item) {
      this.item = item
      // console.log(item)
      // const data = {
      //   observaciones: null,
      //   factura_id: item.item.id,

      // }
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '50%',
        title: 'Finalizar factura',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: { empresa_id: item.item.empresa_id, departamento_id: this.user.departamento_id }
          }
        }
      })
    },
    disableData  ({ item }) {
      const name = (item.activo === 'si') ? 'Desactivar' : 'Activar'
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'disable',
        with: '40%',
        title: `${name} Departamento`,
        body: {
          objectMain: item,
          url: this.get_urls['empresa.departamentos.up-down'],
          message: `¿Estás seguro en ${name} el registro?`,
          description: ''
        },
        confirmButtonText: `Sí, ${name}`,
        cancelButtonText: 'No, Cancelar'
      })
    },
    updateData ({ item }) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '40%',
        title: 'Editar Departamento',
        body: {
          objectMain: item,
          paramsDialog: {
            form: this.get_DepartamentosForm,
            url: this.get_urls['empresa.departamentos.create-update'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    deleteData  ({ item }) {
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'delete',
        with: '40%',
        title: 'Eliminar Departamento',
        body: {
          objectMain: item,
          url: this.get_urls['empresa.departamentos.delete'],
          message: '¿Estás seguro de eliminar el registro?',
          description: 'No podras revertir el movimiento'
        },
        confirmButtonText: 'Sí, Eliminar',
        cancelButtonText: 'No, Cancelar'
      })
    },
    toUploadDoc (item) {
      item.item.eslectura = false
      item.item.tipo = 'RM'
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '55%',
        title: 'Cargar Documentos',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item,
            returnObject: true
          }
        }
      })
    },
    verDocumentos ({ item }) {
      item.esLectura = true
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '55%',
        title: 'Ver documentos',
        body: {
          objectMain: item,
          paramsDialog: {
            form: this.get_DocumentosForm,
            url: '',
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item
          }
        }
      })
    },
    toComplete (item) {
      const data = {
        ubp_ids: item.item.descripcion.ubp_ids,
        tiene_contrato: item.item.descripcion.tiene_contrato,
        contrato_id: item.item.descripcion.contrato_id,
        contrato: item.item.descripcion.contrato,
        unidad_id: item.item.descripcion.unidad_id,
        factura_id: item.item.descripcion.factura_id,
        empleado_id: item.item.descripcion.empleado_id,
        comprador_id: item.item.descripcion.comprador_id,
        comprador: item.item.descripcion.comprador,
        fOrdenSalida: item.item.descripcion.fOrdenSalida,
        departamento_id: item.item.descripcion.departamento_id,
        monto_autorizado: item.item.descripcion.monto_autorizado,
        poliza_devengado: item.item.descripcion.poliza_devengado,
        poliza_comprometido: item.item.descripcion.poliza_comprometido,
        tipo_adjudicacion_id: item.item.descripcion.tipo_adjudicacion_id,
        fuente_financiamiento_id: item.item.descripcion.fuente_financiamiento_id,
        fTurnadoSubdireccionFinanciera: item.item.descripcion.fTurnadoSubdireccionFinanciera,
        poliza_ejercido: item.item.descripcion.poliza_ejercido,
        poliza_pagado: item.item.descripcion.poliza_pagado,
        importe_pagado: item.item.descripcion.importe_pagado,
        fPagado: item.item.descripcion.fPagado,
        linea_captura: item.item.descripcion.linea_captura ?? '',
        banco_id_emisor: item.item.descripcion.banco_id_emisor ?? item.item.f_f.datos_bancarios.banco_id,
        banco_emisor: item.item.banco_emisor ?? item.item.f_f.banco,
        cuenta_bancaria_emisora: item.item.descripcion.cuenta_bancaria_emisora ?? item.item.f_f.datos_bancarios.cuenta,
        clabe_bancaria_emisora: item.item.descripcion.clabe_bancaria_emisora ?? item.item.f_f.datos_bancarios.clabe,
        // ---
        banco_id_receptor: item.item.descripcion.banco_id_receptor ?? item.item.factura.proveedor.datos_bancarios.banco_id,
        banco_receptor: item.item.banco_receptor ?? item.item.factura.proveedor.banco,
        cuenta_bancaria_receptora: item.item.factura.proveedor.datos_bancarios.cuenta,
        clabe_bancaria_receptora: item.item.factura.proveedor.datos_bancarios.clabe
      }
      item.item.eslectura = false
      item.item.tipo = 'RM'
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '55%',
        title: 'Completar datos',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: data,
            returnObject: true
          }
        }
      })
    },
    toUploadDocRF (item) {
      item.item.eslectura = false
      item.item.tipo = 'RF'
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '55%',
        title: 'Cargar Documentos',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item,
            returnObject: true
          }
        }
      })
    },
    toAgregarCuentas (item) {
      const data = {
        ubp_ids: item.item.descripcion.ubp_ids,
        tiene_contrato: item.item.descripcion.tiene_contrato,
        contrato_id: item.item.descripcion.contrato_id,
        contrato: item.item.descripcion.contrato,
        unidad_id: item.item.descripcion.unidad_id,
        factura_id: item.item.descripcion.factura_id,
        empleado_id: item.item.descripcion.empleado_id,
        comprador_id: item.item.descripcion.comprador_id,
        comprador: item.item.descripcion.comprador,
        fOrdenSalida: item.item.descripcion.fOrdenSalida,
        departamento_id: item.item.descripcion.departamento_id,
        monto_autorizado: item.item.descripcion.monto_autorizado,
        poliza_devengado: item.item.descripcion.poliza_devengado,
        poliza_comprometido: item.item.descripcion.poliza_comprometido,
        tipo_adjudicacion_id: item.item.descripcion.tipo_adjudicacion_id,
        fuente_financiamiento_id: item.item.descripcion.fuente_financiamiento_id,
        fTurnadoSubdireccionFinanciera: item.item.descripcion.fTurnadoSubdireccionFinanciera,
        poliza_ejercido: item.item.descripcion.poliza_ejercido,
        poliza_pagado: item.item.descripcion.poliza_pagado,
        importe_pagado: item.item.descripcion.importe_pagado,
        fPagado: item.item.descripcion.fPagado,
        linea_captura: item.item.descripcion.linea_captura ?? '',
        banco_id_emisor: item.item.descripcion.banco_id_emisor ?? item.item.f_f.datos_bancarios.banco_id,
        banco_emisor: item.item.banco_emisor ?? item.item.f_f.banco,
        cuenta_bancaria_emisora: item.item.descripcion.cuenta_bancaria_emisora ?? item.item.f_f.datos_bancarios.cuenta,
        clabe_bancaria_emisora: item.item.descripcion.clabe_bancaria_emisora ?? item.item.f_f.datos_bancarios.clabe,
        // ---
        banco_id_receptor: item.item.descripcion.banco_id_receptor ?? item.item.factura.proveedor.datos_bancarios.banco_id,
        banco_receptor: item.item.banco_receptor ?? item.item.factura.proveedor.banco,
        cuenta_bancaria_receptora: item.item.factura.proveedor.datos_bancarios.cuenta,
        clabe_bancaria_receptora: item.item.factura.proveedor.datos_bancarios.clabe
      }
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '55%',
        title: 'Verificar Cuentas',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: data,
            returnObject: true
          }
        }
      })
    },
    toFinish (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '55%',
        title: 'Finalizar',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item,
            returnObject: true
          }
        }
      })
    },
    toReview (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '35%',
        title: 'Enviar a revision',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item,
            returnObject: true
          }
        }
      })
    },
    toAssingRF (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '35%',
        title: 'Asignar a Recursos Financieros',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item,
            returnObject: true
          }
        }
      })
    },
    toApprove (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '35%',
        title: 'Aprobar',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item,
            returnObject: true
          }
        }
      })
    },
    toReject (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'attend',
        form: 'process',
        with: '55%',
        title: 'Rechazar',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: item.item,
            returnObject: true
          }
        }
      })
    },
    toEdit (item) {
      const caracteristicas = item.item.caracteristicas
      const data = {
        cicl: caracteristicas.cicl,
        fFallo: caracteristicas.fFallo,
        fInicio: caracteristicas.fInicio,
        fSesion: caracteristicas.fSesion,
        contrato: caracteristicas.contrato,
        fApertura: caracteristicas.fApertura,
        expediente: caracteristicas.expediente,
        num_sesion: caracteristicas.num_sesion,
        fPublicacion: caracteristicas.fPublicacion,
        folio_fiscal: caracteristicas.folio_fiscal,
        num_apertura: caracteristicas.num_apertura,
        proveedor_ids: caracteristicas.proveedor_ids,
        proveedor: caracteristicas.proveedor,
        fFinalizacion: caracteristicas.fFinalizacion,
        observaciones: caracteristicas.observaciones,
        importe_con_iva: caracteristicas.importe_con_iva,
        num_parte_junta: caracteristicas.num_parte_junta,
        objeto_contrato: caracteristicas.objeto_contrato,
        fJuntaAclaracion: caracteristicas.fJuntaAclaracion,
        area_contratante_id: caracteristicas.area_contratante_id,
        area_responsable_id: caracteristicas.area_responsable_id,
        area_solicitante_id: caracteristicas.area_solicitante_id,
        tipo_adquisicion_ids: caracteristicas.tipo_adquisicion_ids,
        monto_maximo_con_iva: caracteristicas.monto_maximo_con_iva,
        monto_maximo_sin_iva: caracteristicas.monto_maximo_sin_iva,
        tipo_adjudicacion_id: caracteristicas.tipo_adjudicacion_id,
        fuente_financiamiento_id: caracteristicas.fuente_financiamiento_id,
        monto_autorizado_con_iva: caracteristicas.monto_autorizado_con_iva,
        monto_autorizado_sin_iva: caracteristicas.monto_autorizado_sin_iva
      }
      this.item = item
      this.SHOW_DIALOG_MAIN({
        type: 'assign',
        form: 'process',
        with: '50%',
        title: 'Editar',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['seguimiento.execute'],
            urloption: this.get_urls['seguimiento.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: data
          }
        }
      })
    },
    showDialogFechas (item) {
      this.SHOW_DIALOG_REPORT({
        tittle: 'Reporte de seguimientos',
        urloption: this.get_urls['seguimiento.get-reporte'],
        type: 'xlsx'
      })
    },
    showDialogFechasDoc (item) {
      this.SHOW_DIALOG_REPORT({
        tittle: 'Reporte de documentos',
        urloption: this.get_urls['seguimiento.get-reportedocumentos'],
        type: 'xlsx'
      })
    },
    showDialogFechasFac (item) {
      this.SHOW_DIALOG_REPORT({
        tittle: 'Reporte de Facturas',
        urloption: this.get_urls['seguimiento.facturas-zip'],
        type: 'zip'
      })
    },
    showDialogFechasFacXml (item) {
      this.SHOW_DIALOG_REPORT({
        tittle: 'Reporte de Facturas y XML',
        urloption: this.get_urls['seguimiento.facturas-zip2'],
        type: 'zip'
      })
    },
    capitalizeFirstLetter (str) {
      const capitalized = str.charAt(0).toUpperCase() + str.slice(1)
      return capitalized
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objectPagination', 'get_dialogMain', 'get_sendDataView',
      'get_DepartamentosForm', 'get_DocumentosForm', 'get_filter_seguimientos']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objectPagination (rows) {
      if (rows) {
        this.table.body.data = []
        this.table.header.loading = false
        this.table.body.data = rows.data
        this.table.body.totalData = rows.total
      }
    },
    get_sendDataView ({ name, model }) {
      this.refreshData({})
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }
}
</script>
